import React from 'react';
import { useNotification, NOTIFICATION_TYPES } from '../context/NotificationContext';
import { LuCheck, LuX, LuInfo, LuTriangleAlert } from 'react-icons/lu';

function NotificationCenter() {
    const { notifications, removeNotification } = useNotification();

    const getIcon = (type) => {
        switch (type) {
            case NOTIFICATION_TYPES.SUCCESS:
                return <LuCheck />;
            case NOTIFICATION_TYPES.ERROR:
                return <LuX />;
            case NOTIFICATION_TYPES.WARNING:
                return <LuTriangleAlert />;
            case NOTIFICATION_TYPES.INFO:
            default:
                return <LuInfo />;
        }
    };

    if (notifications.length === 0) return null;

    return (
        <div className="notification-center">
            {notifications.map((notification) => (
                <div
                    key={notification.id}
                    className={`notification-item ${notification.type}`}
                >
                    <span className="notification-icon">{getIcon(notification.type)}</span>
                    <div className="notification-content">
                        {notification.title && (
                            <div className="notification-title">{notification.title}</div>
                        )}
                        {notification.message && (
                            <div className="notification-message">{notification.message}</div>
                        )}
                    </div>
                    <button
                        className="notification-close"
                        onClick={() => removeNotification(notification.id)}
                    >
                        <LuX />
                    </button>
                    {notification.action && (
                        <button
                            className="notification-action"
                            onClick={() => {
                                notification.action.onClick();
                                if (notification.action.closeOnClick !== false) {
                                    removeNotification(notification.id);
                                }
                            }}
                        >
                            {notification.action.label}
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
}

export default NotificationCenter;
